import * as _ from "lodash";
import * as angular from "angular";
import { EmploymentStatusDataProvider } from "../../../data-provider/employment-status.dp";
import { DialogUtils } from "../../../helper/dialog.helper";
import { FormUtils } from "../../../helper/form.helper";

let CanvassRegularFieldComponent = {
    selector: "vcCanvassRegularField",
    templateUrl:
        "/angular/components/canvass/modals/canvass-regular-field.component.html",
    bindings: {
        selectedField: "=",
        canvass: "=",
    },
    controller: class CanvassRegularFieldController {
        // * bindings for typescript compiler *
        public selectedField: any;
        public canvass: any;
        // ************************************

        public canvassRegularFieldForm: any;
        public readonly iconKeys = {
            homephone: "phone",
            mobilephone: "phone_android",
            email: "mail",
            gender: "wc",
            party: "flag",
            yob: "cake",
            dob: "cake",
            volunteer: "insert_emoticon",
            employment: "work",
            deceased: "airline_seat_individual_suite",
            donor: "monetization_on",
            custom: "layers",
        };

        private regularField: any = {};
        private fieldSelectedCopy: any = {};
        private employmentstatuses: any[] = [];
        private dateString = "";
        private cfhodbirthday: string;
        private cfhombirthday: string;
        private cfhoybirthday: string;

        private dialog: DialogUtils;
        private formUtils: FormUtils;
        private employmentStatusDataProvider: EmploymentStatusDataProvider;

        constructor(
            DialogUtils: DialogUtils,
            EmploymentStatusDataProvider: EmploymentStatusDataProvider,
            FormUtils: FormUtils
        ) {
            this.dialog = DialogUtils;
            this.formUtils = FormUtils;
            this.employmentStatusDataProvider = EmploymentStatusDataProvider;

            this.employmentStatusDataProvider
                .all()
                .then((statuses: object[]) => {
                    this.employmentstatuses = statuses;
                });
        }

        $onInit() {
            this.regularField = _.cloneDeep(this.selectedField);
            this.fieldSelectedCopy = _.cloneDeep(this.selectedField);

            if (this.regularField.type == "Date") {
                const d = new Date(this.regularField.value);
                this.cfhodbirthday = ("0" + d.getDate()).slice(-2);
                this.cfhombirthday = ("0" + (d.getMonth() + 1)).slice(-2);
                this.cfhoybirthday = d.getFullYear().toString();
            }

            this.rewriteField(this.fieldSelectedCopy);
        }

        rewriteField(field: any): void {
            if (
                field.hokey &&
                field.hokey != "homephone" &&
                field.hokey.substring(0, 2) == "ho"
            ) {
                field.hokey = field.hokey.substring(2);
            } else {
                if (field.hokey == "esname") field.hokey = "employment";
            }
        }

        confirm(canvassRegularFieldForm: object): void {
            if (this.validateForm(canvassRegularFieldForm)) {
                this.dialog.hide(this.regularField);
            }
        }

        cancel(): void {
            this.dialog.cancel();
        }

        updateEmploymentStatusName(): void {
            let employmentstatuses = this.employmentstatuses.find((elem) => {
                return elem.esname == this.regularField.value;
            });
            this.regularField.esid = employmentstatuses.esid;
        }

        validateForm(formField: object): boolean {
            switch (this.regularField.type) {
                case "Email":
                    return this.validateEmail(this.regularField);
                case "Year":
                    return this.validateYear(this.regularField, formField);
                case "Date":
                    return this.validateDate(this.regularField, formField);
                default:
                    return true;
            }
        }

        validateEmail(emailField: any): boolean {
            if (!angular.isDefined(emailField.value)) {
                return false;
            }

            if (emailField.value != "") {
                const regEx =
                    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (!emailField.value.match(regEx)) {
                    this.canvassRegularFieldForm.email.$setValidity(
                        "badEmail",
                        false
                    );
                    return false;
                }
            }

            return true;
        }

        validateYear(
            yearField: any | number | string,
            formField: any
        ): boolean {
            let year =
                yearField && angular.isDefined(yearField.value)
                    ? yearField.value
                    : yearField;
            let yearValid = this.formUtils.birthYearValid(year);
            formField.birthYear.$setValidity("badYear", yearValid);
            return yearValid;
        }

        validateDate(dateField: any, formField: any): boolean {
            if (
                !(
                    (angular.isDefined(this.cfhoybirthday) &&
                        this.cfhoybirthday != "") ||
                    (angular.isDefined(this.cfhombirthday) &&
                        this.cfhombirthday != "") ||
                    (angular.isDefined(this.cfhodbirthday) &&
                        this.cfhodbirthday != "")
                )
            ) {
                //None of the 3 inputs has data don't validate.
                dateField.value = null;
                return true;
            }
            if (
                !this.validateYear(formField.birthYear.$modelValue, formField)
            ) {
                return false;
            }

            this.dateString =
                this.cfhoybirthday +
                "-" +
                this.cfhombirthday +
                "-" +
                this.cfhodbirthday;
            if (
                this.formUtils.dateIsReal(
                    this.cfhodbirthday,
                    this.cfhombirthday,
                    this.cfhoybirthday
                )
            ) {
                dateField.value = this.dateString;
                formField.day.$setValidity("badDate", true);
                return true;
            }

            formField.day.$setValidity("badDate", false);
            return false;
        }

        checkDayIsReal(formField: any): boolean {
            const valid = this.formUtils.dateIsReal(
                this.cfhodbirthday,
                this.cfhombirthday,
                this.cfhoybirthday
            );
            if (valid) {
                formField.day.$setValidity("badDate", true);
            }
            return valid;
        }
    },
};

angular
    .module("canvass")
    .component(
        CanvassRegularFieldComponent.selector,
        CanvassRegularFieldComponent
    );
